(function () {
  angular
    .module('app.widgets.common.ie-eleven-notification')
    .constant('IE11_BANNER_DISMISSED', 'IE11_BANNER_DISMISSED');
})();
